import { render, staticRenderFns } from "./AppPhotoSwipeLib.vue?vue&type=template&id=5f61859e"
import script from "./AppPhotoSwipeLib.vue?vue&type=script&lang=js"
export * from "./AppPhotoSwipeLib.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports